import React, { useState } from 'react';
import { Card, Button, Tooltip } from 'antd';
import { EditFilled, DeleteFilled, MenuOutlined, CopyOutlined } from '@ant-design/icons';
import PanelVisualization from '../panels/PanelVisualization';
import QueryRunner from '../panels/QueryRunner';
import { useTheme } from '../../context/ThemeContext';

const PanelWrapper = ({
  panel,
  refreshKey,
  timeRange,
  variables,
  onEdit,
  onDelete,
  onDuplicate,
  onDataUpdate,
  onLoading,
  onError,
}) => {
  const { isDark } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      title={
        <span 
          className="panel-drag-handle" 
          style={{ 
            cursor: 'grab', 
            display: 'inline-flex', 
            alignItems: 'center', 
            gap: 6,
            fontSize: 13,
            fontWeight: 500,
            color: isDark ? '#e6edf3' : '#262626'
          }}
        >
          <MenuOutlined 
            style={{ 
              color: isDark ? '#484f58' : 'rgba(0,0,0,0.2)', 
              fontSize: 10,
              opacity: isHovered ? 1 : 0,
              transition: 'opacity 0.2s'
            }} 
          />
          {panel.title}
        </span>
      }
      size="small"
      style={{ 
        height: '100%',
        background: isDark ? '#0d1117' : '#fff',
        border: isDark ? '1px solid #30363d' : '1px solid #e0e0e0',
        borderRadius: 4,
        boxShadow: isHovered 
          ? (isDark ? '0 2px 8px rgba(0,0,0,0.4)' : '0 2px 8px rgba(0,0,0,0.1)')
          : 'none',
        transition: 'box-shadow 0.2s ease'
      }}
      headStyle={{
        background: isDark ? '#161b22' : '#fafafa',
        borderBottom: isDark ? '1px solid #30363d' : '1px solid #f0f0f0',
        padding: '4px 12px',
        minHeight: 32,
        fontSize: 13
      }}
      bodyStyle={{ 
        height: 'calc(100% - 32px)', 
        padding: 8, 
        overflow: 'auto',
        background: isDark ? '#0d1117' : '#fff'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      extra={
        <div 
          style={{ 
            display: 'flex', 
            gap: 2,
            opacity: isHovered ? 1 : 0,
            transition: 'opacity 0.2s'
          }} 
          onClick={(e) => e.stopPropagation()}
        >
          <Tooltip title="Edit">
            <Button
              type="text"
              size="small"
              icon={<EditFilled style={{ fontSize: 12 }} />}
              onClick={() => onEdit(panel.id)}
              style={{
                color: isDark ? '#8b949e' : '#595959',
                padding: '0 4px',
                height: 22
              }}
            />
          </Tooltip>
          {typeof onDuplicate === 'function' && (
            <Tooltip title="Duplicate">
              <Button
                type="text"
                size="small"
                icon={<CopyOutlined style={{ fontSize: 12 }} />}
                onClick={() => onDuplicate(panel.id)}
                style={{
                  color: isDark ? '#8b949e' : '#595959',
                  padding: '0 4px',
                  height: 22
                }}
              />
            </Tooltip>
          )}
          <Tooltip title="Delete">
            <Button
              type="text"
              size="small"
              icon={<DeleteFilled style={{ fontSize: 12 }} />}
              danger
              onClick={() => onDelete(panel.id)}
              style={{
                padding: '0 4px',
                height: 22
              }}
            />
          </Tooltip>
        </div>
      }
    >
      {/* Query execution logic */}
      <QueryRunner
        panel={panel}
        refreshKey={refreshKey}
        timeRange={timeRange}
        variables={variables}
        onDataUpdate={(data) => onDataUpdate(panel.id, data)}
        onLoading={(loading) => onLoading(panel.id, loading)}
        onError={(error) => onError(panel.id, error)}
      />
      
      {/* Visualization rendering */}
      <PanelVisualization panel={panel} />
    </Card>
  );
};

export default PanelWrapper;